import { render, staticRenderFns } from "./ExamComponent.vue?vue&type=template&id=9aa9db10&"
import script from "./ExamComponent.vue?vue&type=script&lang=js&"
export * from "./ExamComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExamComponent.vue?vue&type=style&index=0&id=9aa9db10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports